// components/AdminRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

export default function AdminRoute({ children }) {
  const { userState } = useUser();

  if (!userState.isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (!userState.isAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
